export enum FloorStaleTimeEnum {
  GetFloorPlan = 60000,
  GetFloor = 360000,
  GetFloorsSearch = 36000,
  GetFloorPlanResources = 60000,
}
